import {memo, useCallback, useEffect, useMemo, useState} from "react";
import s from './ModalOptionsDesktop.module.css';

export const ModalOptionsDesktop = memo(({
  isOpen,
  handleClose,
  style,
  getModalContent,
}) => {

  const [isShowContent, setIsShowContent] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsShowContent(isOpen), 0);
  }, [isOpen, setIsShowContent]);

  const handleCloseModal = useCallback(() => {
    setIsShowContent(false);
    setTimeout(handleClose, 200);
  }, [setIsShowContent, handleClose]);

  const memoizedModalContent = useMemo(
    () => getModalContent({handleCloseModal}),
    [getModalContent, handleCloseModal]
  );

  return (
    <div className={s.wrapper}>
      <div
        className={s.fon}
        style={{opacity: isShowContent ? 1 : 0}}
        onClick={handleCloseModal}
      />
      <div className={s.container}>
        <div
          className={s.block}
          style={{opacity: isShowContent ? 1 : 0, ...style}}
        >
          {memoizedModalContent}
        </div>
      </div>
    </div>
  );
});